import React from 'react';
import { TbCheck, TbX } from 'react-icons/tb';
import { Link, useLocation } from 'react-router-dom';

export const BoostReturnPage = () => {
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const successMessage = queryParams.get('success');
  const cancelMessage = queryParams.get('cancel');

  return (
    <div className="max-w-5xl mt-24">
      {successMessage && (
        <div className="rounded-md bg-green/20 p-4">
          <div className="flex">
            <div className="flex-shrink-0">
              <TbCheck aria-hidden="true" className="h-7 w-7 text-green" />
            </div>
            <div className="ml-3">
              <h3 className="text-xl text-green font-bold">Publicité bien reçu !</h3>
              <div className="my-5 text-sm text-green">
                <p>
                  Il sera actif dans <strong>maximum 24h</strong> sur mon-resto-halal.com
                </p>
                <p>
                  Une question ? N'hésitez pas à nous contacter à{' '}
                  <a className="font-semibold underline underline-offset-2" href="mailto:salam@mon-resto-halal.com">
                    salam@mon-resto-halal.com
                  </a>
                </p>
              </div>
              <Link to="/" className="mt-4">
                <button
                  type="button"
                  className="rounded-md bg-green/50 px-2 py-1.5 text-sm font-medium text-white hover:bg-green/60 focus:outline-none focus:ring-2 focus:ring-green focus:ring-offset-2 focus:ring-offset-green"
                >
                  Retour à mon dashboard
                </button>
              </Link>
            </div>
          </div>
        </div>
      )}
      {cancelMessage && (
        <div className="rounded-md bg-red-50 p-4">
          <div className="flex">
            <div className="flex-shrink-0">
              <TbX aria-hidden="true" className="h-7 w-7 text-red-800" />
            </div>
            <div className="ml-3">
              <h3 className="text-xl text-red-800 font-bold">Vous avez annulé le paiement</h3>
              <div className="my-5 text-sm text-red-500">
                <p>
                  Votre publicité <strong>n'est pas active</strong>. Vous pouvez la relancer à tout moment sur votre dashboard.
                </p>
                <p>
                  Une question ? N'hésitez pas à nous contacter à <strong>salam@mon-resto-halal.com</strong>
                </p>
              </div>
              <Link to="/" className="mt-4">
                <button
                  type="button"
                  className="rounded-md bg-red-500 px-2 py-1.5 text-sm font-medium text-white hover:bg-red-500/80 focus:outline-none focus:ring-2 focus:ring-red-600 focus:ring-offset-2 focus:ring-offset-red-600"
                >
                  Retour à mon dashboard
                </button>
              </Link>
            </div>
          </div>
        </div>
      )}

      {!successMessage && !cancelMessage && (
        <div className="rounded-md bg-shades-primary-active/20 p-10">
          <h3 className="text-xl text-primary font-bold">Retour à mon dashboard</h3>

          <Link to="/">
            <button
              type="button"
              className="rounded-md mt-5 bg-primary px-2 py-1.5 text-sm font-medium text-white hover:bg-shades-primary-hover focus:outline-none focus:ring-2 focus:ring-green-605 focus:ring-offset-2 focus:ring-offset-primary"
            >
              Retour à mon dashboard
            </button>
          </Link>
        </div>
      )}
    </div>
  );
};
